import { useState } from "react";
import { observer } from "mobx-react-lite";
import { Button, Flex, Typography } from "antd";
import returnIcon from "images/return.svg";
import { useStores } from "stores";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { getBidBalance, getRefundNative } from "services";

import styles from "./returnButton.module.css";

export const ReturnNativesButton = observer(() => {
  const { bidCard, actionModals } = useStores();
  const [loading, setLoading] = useState(false);

  const { network, id } = bidCard.bid;

  const handleReturnNatives = async () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text={`Вы уверены, что хотите вернуть ${network}?`}
          successText="Запрос успешно отправлен"
          buttonText="Вернуть"
          calledQuery={() => getRefundNative({ id })}
          onSuccess={() => {
            setTimeout(async () => {
              handleUpdateBalance();
            }, 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  const handleUpdateBalance = async () => {
    setLoading(true);
    await getBidBalance({ id })
      .then(() => {
        setTimeout(async () => {
          await bidCard.updateCardById(id);
          if (bidCard.bid.balance && +bidCard.bid.balance.native > 0) {
            handleUpdateBalance();
          } else {
            setLoading(false);
          }
        }, 1500);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  return (
    <Button
      type="link"
      size="middle"
      className={`${styles.syncButton} grey-border`}
      onClick={handleReturnNatives}
      disabled={loading}
    >
      <Flex align="center" gap="4px" className={styles.syncButtonText}>
        <img src={returnIcon} className={styles.syncIcon} />
      </Flex>
    </Button>
  );
});
